// extracted by css-extract-rspack-plugin
export default {"thumb":"_a8f1c0cf","active":"_2d448445","heroImage":"_3f5b8c7e","image":"_1ee37e8e","viewInRoomOverlay":"_686c686","viewInRoomIcon":"_c6eb8ab7"};